import { Component } from "react";
import { connect } from "react-redux";
import { BetSlipHelper } from "../../../../../../../../../../../helpers/betSlipHelper";
import { marketPeriodHelper } from "../../../../../../../../../../../helpers/marketPeriodHelper";
import type {
  EventMarketType,
  EventType,
} from "../../../../../../../../../../../types/eventType";
import { MarketTypes } from "../../../../../../../../../../../utils/const";
import RenderOddsComponent from "../RenderOddsComponent/RenderOddsComponent";
import "./BinaryMarketRunnerDetails.scss";
type Props = {
  event: EventType;
  market: EventMarketType;
  marketType: Record<string, any>;
  addBetSlip: (...args: Array<any>) => any;
};

class BinaryMarketRunnerDetails extends Component<Props> {
  addBetSlip = (runner: Record<string, any>) => {
    let betSlip = BetSlipHelper.prepareBetSlip(this.props.event, runner);
    this.props.addBetSlip(betSlip);
  };

  render() {
    const { event, market, marketType } = this.props;
    return (
      <div className={`market binary ${market.status.toLowerCase()}`}>
        {market.runners.map(runner => {
          // BET-7545 - Quick fix for hotfix - TOTAL formatting logic can be removed after API change
          const handicap =
            market.marketInternalType &&
            market.marketInternalType.includes(MarketTypes.TOTAL) &&
            runner.modalFormattedHandicap
              ? runner.modalFormattedHandicap.replace(/\+/g, "")
              : runner.modalFormattedHandicap || runner.handicap;

          if (marketPeriodHelper.shouldHideRunner(runner)) {
            return (
              <span
                key={"binary" + runner.id}
                className={"binary-market__runner--empty"}
              ></span>
            );
          }

          return (
            <span
              key={"binary" + runner.id}
              onClick={() => {
                this.addBetSlip(runner);
              }}
              className={"binary-market__runner"}
            >
              {handicap && (
                <div
                  className={`runner__name ${
                    runner.modalFormattedHandicap && "handicap"
                  }`}
                >
                  {handicap}
                </div>
              )}
              <RenderOddsComponent
                event={event}
                runner={runner}
                marketType={marketType}
              />
            </span>
          );
        })}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addBetSlip: (betSlip: EventType) =>
      dispatch.betSlipListModel.addBetSlip(betSlip),
  };
}

export default connect(
  null,
  mapDispatchToProps
)(BinaryMarketRunnerDetails) as any;
